<div class="p-4 max-w-3xl mx-auto">
  <div class="flex justify-between items-center mb-6">
    <h2 class="text-2xl font-bold">
      {{ '::NewOrder' | abpLocalization }}
    </h2>
  </div>

  @if (form) {
  <form class="gap-2" [formGroup]="form" (ngSubmit)="save()">

    <div class="grid grid-cols-2 gap-4 items-start">
      <app-metro-form-select label="{{ '::Sommelier' | abpLocalization }}" formControlName="sommelierId"
        [options]="sommeliers" placeholder="{{ '::SelectSommelier' | abpLocalization }}">
      </app-metro-form-select>

      <app-metro-form-select label="{{ '::Customer' | abpLocalization }}" formControlName="userId" [options]="users"
        placeholder="{{ '::SelectUser' | abpLocalization }}" (selectionChange)="onUserChange($event)">
      </app-metro-form-select>
    </div>

    <!-- General Info -->
    <div class="grid grid-cols-2 gap-4 items-start">
      <app-metro-form-select label="{{ '::DeliveryMethod' | abpLocalization }}" formControlName="deliveryMethod"
        [options]="deliveryMethodOptions" [placeholder]="'::DeliveryMethod' | abpLocalization" size="md"
        [allowSearch]="false">
      </app-metro-form-select>

      <app-metro-form-select label="{{ '::PaymentMethod' | abpLocalization }}" formControlName="paymentMethod"
        [options]="paymentMethodOptions" [placeholder]="'::PaymentMethod' | abpLocalization" size="md"
        [allowSearch]="false">
      </app-metro-form-select>
    </div>


    <!-- Shipping Address - Show ONLY for Shipping -->
    <div *ngIf="form.get('deliveryMethod').value === 'shipping'">
      <h6 class="mt-4">{{ '::ShippingAddress' | abpLocalization }}</h6>
      <div class="grid grid-cols-2 gap-3 items-start">
        <app-metro-form-input label="{{ '::Address' | abpLocalization }}" formControlName="shippingAddressLine"
          [placeholder]="'::Address' | abpLocalization">
        </app-metro-form-input>

        <app-metro-form-input label="{{ '::City' | abpLocalization }}" formControlName="city"
          [placeholder]="'::City' | abpLocalization">
        </app-metro-form-input>

        <app-metro-form-input label="{{ '::State' | abpLocalization }}" formControlName="state"
          [placeholder]="'::State' | abpLocalization">
        </app-metro-form-input>

        <div class="grid grid-cols-2 gap-2">
          <app-metro-form-input label="{{ '::PostalCode' | abpLocalization }}" formControlName="postalCode"
            [placeholder]="'::PostalCode' | abpLocalization">
          </app-metro-form-input>

          <app-metro-form-input label="{{ '::Country' | abpLocalization }}" formControlName="country"
            [placeholder]="'::Country' | abpLocalization">
          </app-metro-form-input>
        </div>
      </div>
    </div>

    <!-- Pickup Point Selector - Show ONLY for Pickup -->
     @if (form.get('deliveryMethod').value === 'pickup') {
    <div class="mt-4">
      <app-metro-form-select label="{{ '::SelectPickupLocation' | abpLocalization }}" formControlName="shippingAddressLine"
        [options]="pickUpsOptions" placeholder="{{ '::PickupLocation' | abpLocalization }}" [allowSearch]="false">
      </app-metro-form-select>

      @if (pickups.length === 0 && form.get('sommelierId').value) {
      <div class="text-red-500 text-sm mt-1">
        {{ '::NoPickupsFoundForSommelier' | abpLocalization }}
      </div>
    }
    </div>
  }



    <!-- Order Items -->
    <h6 class="mt-4 d-flex justify-content-start align-items-center">
      {{ '::Wines' | abpLocalization }}
      <app-metro-button class="ml-2" variant="secondary" text="{{ '::AddWine' | abpLocalization }}" type="button"
        (clicked)="addOrderItem()">
      </app-metro-button>
      @if (orderItems.invalid && form.touched && orderItems.length === 0) {
      <small class="text-danger ml-2">
        {{ '::AtLeastOneWineRequired' | abpLocalization }}
      </small>}
    </h6>

    <!-- Order Items Headers -->
    @if (orderItems.controls.length > 0) {
    <div class="row mb-1 px-3">
      <div class="col-md-5">
        <label>{{ '::Wine' | abpLocalization }}</label>
      </div>
      <div class="col-md-2">
        <label>{{ '::Quantity' | abpLocalization }}</label>
      </div>
      <div class="col-md-3">
        <label>{{ '::Price' | abpLocalization }}</label>
      </div>
      <div class="col-md-2">
      </div>
    </div>
    }

    <div formArrayName="orderItems">
      @for (item of orderItems.controls; track item; let i = $index) {
      <div [formGroupName]="i" class="card mb-2 p-2">

        <div class="grid grid-cols-12 gap-2 items-center">

          <div class="col-span-6 mt-2">
            <app-metro-form-select formControlName="wineId" [options]="wineOptions"
              [placeholder]="'::SelectWine' | abpLocalization">
            </app-metro-form-select>
          </div>

          <div class="col-span-2">
            <app-metro-form-input formControlName="quantity" type="number">
            </app-metro-form-input>
          </div>

          <div class="col-span-3">
            <div class="relative">
              <app-metro-form-input formControlName="unitPrice" type="number">
              </app-metro-form-input>
              @if (form.get('priceListId')?.value && item.get('wineId')?.value) {
              <div class="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-help" [title]="isWineInPriceList(item.get('wineId')?.value) ?
                    'Precio actualizado desde la lista de precios seleccionada' :
                    'Este vino no está en la lista de precios. Se usa precio por defecto.'">
                @if (isWineInPriceList(item.get('wineId')?.value)) {
                <span
                  class="inline-flex items-center justify-center w-5 h-5 rounded-full bg-green-100 text-green-600 text-xs font-semibold">
                  ✓
                </span>
                } @else {
                <span
                  class="inline-flex items-center justify-center w-5 h-5 rounded-full bg-orange-100 text-orange-600 text-xs font-semibold">
                  !
                </span>
                }
              </div>
              }
            </div>
          </div>
          <div class="col-span-1 flex justify-center items-center">
            <button type="button"
              class=" w-9 h-9 flex items-center justify-center rounded-md bg-red-500 text-white text-lg font-semibold  hover:bg-red-600 transition"
              (click)="removeOrderItem(i)">
              ×
            </button>
          </div>
        </div>
      </div>
      }
    </div>


    <div class="grid grid-cols-2 gap-4">
      <app-metro-form-select formControlName="priceListId" [options]="priceLists"
        [placeholder]="'::SelectPriceList' | abpLocalization" [allowSearch]="false" size="md">
      </app-metro-form-select>
    </div>

    @if (form.get('priceListId')?.value && currentPriceListItems.length > 0 && orderItems.controls.length > 0) {
    <!-- @for con track por priceListId: fuerza recrear el cupón (limpia su estado visual) si cambia la lista de precios -->
    @for (plId of [form.get('priceListId')?.value]; track plId) {
    <div class="mt-3">
      <app-coupon-input [orderTotal]="orderTotal" [items]="couponItems" [sommelierId]="couponSommelierId" [clientUserId]="form.get('userId')?.value"
        [persistKey]="couponPersistKey" (couponApplied)="onCouponApplied($event)" (couponRemoved)="onCouponRemoved()">
      </app-coupon-input>
    </div>
    }
    }

    <div class="form-group mt-3">
      <app-metro-form-textarea rows="3" label='{{"::Notes" | abpLocalization}}' formControlName="notes" size="md"
        type="text">
      </app-metro-form-textarea>
    </div>

    <div class="d-flex justify-content-end mt-4">
      <app-metro-button variant="secondary" text="{{ '::Cancel' | abpLocalization }}" type="button"
        (clicked)="backToOrders()" [disabled]="isSaving">
      </app-metro-button>

      <app-metro-button class="ml-2" variant="primary" type="submit" text="{{ '::Save' | abpLocalization }}"
        [disabled]="isLoading || isSaving || form.invalid" [loading]="isSaving">
      </app-metro-button>
    </div>

  </form>
  }

  @if (isSaving) {
    <div class="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex flex-col items-center justify-center gap-4 animate-fade-in">
      <div class="donut !w-12 !h-12 !border-4 !border-white/20 !border-l-white"></div>
      <span class="text-white font-medium text-lg">{{ '::Saving' | abpLocalization }}...</span>
    </div>
  }
</div>
